// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"204":"101a27b4","568":"3676de88"}[chunkId] + ".chunk.css";
};